import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "UX Strategy",
  "Design Leadership",
  "Agentic AI",
  "Research",
  "Design Systems",
  "Enterprise Scale",
];

export const EditorialMarquee = () => {
  return (
    <section className="py-16 sm:py-24 overflow-hidden border-y hairline" data-testid="editorial-marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="marquee-item inline-flex items-center">
            {w}
            <span className="mx-8 inline-block h-3 w-3 rounded-full align-middle" style={{ background: "var(--accent)" }} />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
